import { FC, ReactNode } from 'react';
import { isEmpty } from 'lodash';

import { FeatureFlag, useFeatureFlagsContext } from '@app/contexts';
import { FeatureFlagToMatch } from '@app/constants';

interface FeatureFlagsProps {
  flagsToMatch?: FeatureFlagToMatch[];
  renderOn?: (flags: FeatureFlag[]) => ReactNode;
  renderOff?: (flags: FeatureFlag[]) => ReactNode;
}

export const FeatureFlags: FC<FeatureFlagsProps> = ({
  flagsToMatch,
  children,
  renderOn,
  renderOff,
}) => {
  const featureFlags = useFeatureFlagsContext();

  if (!flagsToMatch) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  const matchedFlags = flagsToMatch.reduce<FeatureFlag[]>(
    (result, flagToMatch) => {
      const featureFlag = featureFlags.find(
        flag => flag.name === flagToMatch.name
      );

      if (!featureFlag) {
        return flagToMatch.isActiveIfNotFound
          ? result.concat({ name: flagToMatch.name, isActive: true })
          : result;
      }

      return featureFlag.isActive ? result.concat(featureFlag) : result;
    },
    []
  );

  const resolveRender = () => children ?? renderOn?.(matchedFlags);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{!isEmpty(matchedFlags) ? resolveRender() : renderOff?.(matchedFlags)}</>
  );
};
